/**
 * MiniStats — DS Chart
 * Carte KPI compacte : valeur + delta + label + icône
 */

import styles from './MiniStats.module.css';

interface MiniStatsProps {
  label: string;
  value: string | number;
  delta?: number;
  deltaLabel?: string;
  icon?: string;
  variant?: 'primary' | 'action' | 'neutral';
  className?: string;
}

export function MiniStats({ label, value, delta, deltaLabel, icon, variant = 'primary', className = '' }: MiniStatsProps) {
  const positive = delta !== undefined && delta >= 0;
  return (
    <div className={`${styles.card} ${className}`}>
      <div className={styles.top}>
        <span className={styles.label}>{label}</span>
        {icon && <i className={`bi ${icon} ${styles.icon} ${styles[variant]}`} />}
      </div>
      <div className={styles.value}>{value}</div>
      {delta !== undefined && (
        <div className={`${styles.delta} ${positive ? styles.positive : styles.negative}`}>
          <i className={`bi bi-arrow-${positive ? 'up' : 'down'}-short`} />
          {Math.abs(delta)}% {deltaLabel}
        </div>
      )}
    </div>
  );
}
